import { isMobile } from 'react-device-detect';

// Used to prevent iOS browsers from scrolling the body.

let scrollPosition = 0;
let body;
const DISABLE_SCROLLING_CLASS = 'modal-scroll-disabled';

export default {
  enable() {
    if (isMobile) {
      scrollPosition = window.pageYOffset;

      body = document.querySelector('body');
      body.classList.add(DISABLE_SCROLLING_CLASS);
      body.style.top = `-${scrollPosition}px`;
    }
  },
  disable() {
    if (isMobile) {
      if (!body) {
        return;
      }

      body.classList.remove(DISABLE_SCROLLING_CLASS);
      body.style.removeProperty('top');

      window.scrollTo(0, scrollPosition);
    }
  },
};
